import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../pages/Auth';
import { BrandLoader } from '../BrandLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted dark:bg-[#0B1120]">
        <BrandLoader label="Loading…" />
      </div>
    );
  }

  // Redirect to auth page if not authenticated — keeping any intent params
  // (e.g. plan=pro) so the auth page can resume the flow afterwards.
  if (!isAuthenticated) {
    return <Navigate to={`/auth${location.search}`} replace />;
  }

  // Render protected content
  return <>{children}</>;
}

